const awsExports = {
    "region" : "ap-south-1",
    "userPoolId": "ap-south-1_9rvgauwmF",
    "userPoolWebClientId": "5t8su893pa65rkoqbs1e1ifv8d"
};

export default awsExports;